// MA-343 — /journey: the third kid tab (Practice · Read · Journey).
//
// New top-level route (not a /play sub-route): the fold-derived chapter
// path stops being a /play secondary view and becomes a peer tab, per
// the converged design spec (docs/build/specs/MA-343-journey-tab-design.md
// §2). URL is kid-invisible.

import { createFileRoute } from "@tanstack/react-router";
import { JourneyPath } from "@/screens/JourneyPath";

export const Route = createFileRoute("/journey")({
  component: JourneyPath,
});
